module.exports = __webpack_public_path__ + "img/pop-bg.5cc79194.png";